import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Tracking",
    redirect: 'tracking',
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login")
  },
  {
    path: "/tracking",
    name: "Tracking",
    component: () => import("@/views/UserTracking")
  },
  {
    name: 'Bookings',
    path: '/bookings',
    component: () => import('@/views/dashboard/Index'),
    children: [
      {
        name: 'Bookings',
        path: '',
        component: () => import('@/views/dashboard/pages/Booking'),
      },
      {
        name: 'Tracking',
        path: 'tracking',
        component: () => import('@/views/dashboard/component/Tracking'),
      },
      {
        name: 'BookingsDetail',
        path: ':id',
        component: () => import('@/views/dashboard/pages/BookingDetail')
      },
    ]
  },
  // {
  //   path: '/asd',
  //   component: () => import('@/views/dashboard/Index'),
  //   children: [
  //     // Dashboard
  //     {
  //       name: 'Dashboard',
  //       path: '',
  //       redirect: 'bookings',
  //       // component: () => import('@/views/dashboard/Dashboard'),
  //     },
  //     {
  //       name: 'Bookings',
  //       path: 'bookings',
  //       component: () => import('@/views/dashboard/pages/Booking'),
  //     },
  //     {
  //       name: 'BookingsDetail',
  //       path: 'bookings/:id',
  //       component: () => import('@/views/dashboard/pages/BookingDetail')
  //     },
  //     // Pages
  //     {
  //       name: 'User Profile',
  //       path: 'pages/user',
  //       component: () => import('@/views/dashboard/pages/UserProfile'),
  //     },
  //     {
  //       name: 'Notifications',
  //       path: 'components/notifications',
  //       component: () => import('@/views/dashboard/component/Notifications'),
  //     },
  //     {
  //       name: 'Icons',
  //       path: 'components/icons',
  //       component: () => import('@/views/dashboard/component/Icons'),
  //     },
  //     {
  //       name: 'Typography',
  //       path: 'components/typography',
  //       component: () => import('@/views/dashboard/component/Typography'),
  //     },
  //     {
  //       name: 'Tracking',
  //       path: 'components/tracking',
  //       component: () => import('@/views/dashboard/component/Tracking'),
  //     },
  //     // Tables
  //     {
  //       name: 'Regular Tables',
  //       path: 'tables/regular-tables',
  //       component: () => import('@/views/dashboard/tables/RegularTables'),
  //     },
  //     // Maps
  //     {
  //       name: 'Google Maps',
  //       path: 'maps/google-maps',
  //       component: () => import('@/views/dashboard/maps/GoogleMaps'),
  //     },
  //   ],
  // },
  {
    path: "/*",
    name: "Tracking",
    redirect: 'tracking',
  },
];

const router = new VueRouter({
  routes
});

export default router;
